import { Badge, Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StackOrModal } from "../../../../../mantine/components/StackOrModal/StackOrModal";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getConsumptionMarketLocationNumbersColumn(
  invoices: Array<PPAInvoice>
): MRT_ColumnDef<PPAInvoice> {
  const usedConsumptionSites = invoices
    .map((invoice) => invoice.consumption_market_location_numbers)
    .flat();
  const usedConsumptionMarketLocationNumbers = Array.from<string>(
    new Set(usedConsumptionSites)
  );
  const uniqueUsedConsumptionMarketLocationNumbers = Array.from(
    usedConsumptionMarketLocationNumbers
  ).sort();

  return {
    accessorKey: "consumption_market_location_numbers",
    header: "Verbrauchsstelle",
    enableSorting: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedConsumptionMarketLocationNumbers
    },
    filterFn: "arrIncludesSome",
    size: 210,
    Cell: ({ table, row }) => {
      const search = table.getState().globalFilter ?? "";

      return (
        <StackOrModal
          elementText="Verbrauchsstellen"
          numElements={row.original.consumption_market_location_numbers.length}
        >
          {row.original.consumption_market_location_numbers.map((site) => (
            <Badge color="gray" key={site} variant="outline">
              <Highlight highlight={search}>{site}</Highlight>
            </Badge>
          ))}
        </StackOrModal>
      );
    }
  };
}
